import dayjs from "@/lib/day";

/**
 * calcCampaignEndAt.
 *
 * キャンペーンに設定された適用回数をもとにキャンペーン終了日時を計算する
 *
 * @param {Object} campaign
 * @param {string} initialTransactionAt
 */
export default function calcCampaignEndAt(campaign, initialTransactionAt) {
  const validityEndAt = campaign?.validityEndAt;
  const applyCount = campaign?.discountApplyCount || 0;
  if (applyCount > 0) {
    const endAt = dayjs(new Date(initialTransactionAt))
      .add(applyCount, "month")
      .subtract(1, "day");
    if (endAt.isAfter(validityEndAt)) {
      return validityEndAt;
    } else {
      return endAt.format("YYYY/MM/DD");
    }
  } else {
    return validityEndAt;
  }
}
